<template>
	<div id="app">
		<router-view />
		<!-- <hint v-if="tipsShow" @closeTips="closeTips" :docWidth="docWidth" :docHeight="docHeight"/> -->
	</div>
</template>

<script>
// import hint from '@/components/Hint.vue'
import { getSysWebsite, showUrl, savePortalVisitStatistic, loginOut } from '@/api/api'
import Cookies from 'js-cookie'
export default {
	name: 'App',
	components: {},
	data() {
		return {
			tipsShow: false,
			docWidth: '',
			docHeight: '',
			beforeUnload: '',
			Handler: ''
		}
	},
	created() {
		this.getSysWebsite()
	},
	mounted() {
		this.getWindowParams()
		// 监听浏览器关闭清空token
		// window.addEventListener('beforeunload', this.handleBeforeUnload)
		// window.addEventListener('unload', this.handleUnload)
	},
	destroyed() {
		// window.removeEventListener('beforeunload', this.handleBeforeUnload)
		// window.removeEventListener('unload', this.handleUnload)
	},
	methods: {
		handleBeforeUnload(event) {
			this.beforeUnload = new Date().getTime()
		},
		// 浏览器关闭清空token
		handleUnload(event) {
			this.Handler = new Date().getTime() - this.beforeUnload
			// console.log('handler',this.Handler);
			//判断是窗口关闭还是刷新
			if (this.Handler <= 3) {
				// 兼容火狐的做法
				event.preventDefault()
				event.returnValue = ''
                localStorage.clear()
                Cookies.remove("access_token")
				// 退出登录,清空token
                // let data = {
                //     identify: this.$variable.identify
                // }
                // loginOut(data).then(res => {
                //     if (res.code == 0) {
                //         localStorage.clear()
                //         this.$store.dispatch('permission/setToken', '')
                //     } else {
                //         localStorage.clear()
                //     }
                // })
			}
		},
		// 获取获取设置信息
		getSysWebsite() {
			let data = {}
			getSysWebsite(data).then(res => {
				if (res.code == 0) {
					this.phone = res.data.phone
					this.email = res.data.email
					localStorage.setItem('basicSet', JSON.stringify(res.data))
					this.getSysIcon()
				}
			})
		},
		// 处理系统角标
		getSysIcon() {
			// 设置动态角标
			var linkzh = document.createElement('link')
			linkzh.setAttribute('rel', 'icon')
			if (localStorage.getItem('basicSet')) {
				var basicSet = JSON.parse(localStorage.getItem('basicSet'))
				linkzh.setAttribute('href', showUrl + basicSet.cornerLogo)
				// linkzh.setAttribute('href','https://img.alicdn.com/imgextra/i2/O1CN01ZyAlrn1MwaMhqz36G_!!6000000001499-73-tps-64-64.ico')
			} else {
				linkzh.setAttribute('href', '<%= BASE_URL %>favicon.ico')
			}
			document.getElementsByTagName('head')[0].appendChild(linkzh)
		},
		getWindowParams() {
			this.docWidth = document.documentElement.clientWidth
			this.docHeight = document.documentElement.clientHeight

			if (this.docWidth < 1920 || this.docHeight < 1080) {
				this.tipsShow = true
			}
		},
		closeTips() {
			this.tipsShow = false
		},
	},
	watch: {
		$route: {
			handler(val) {
				if (val.path != '/platform/arcitle') {
					let pathUrl = val.path
					let pathName = val.meta.title
					let data = {
						pageName: pathName,
						pageUrl: pathUrl,
					}
					savePortalVisitStatistic(data).then(res => {
						if (res.code == 0) {

						}
					})
				}
			},
			deep: true,
			// immediate:true,
		}
	}
}
</script>

<style>
#app {
	font-family: Avenir, Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	color: #222222;
	min-width: 1280px;
}
</style>
